// Submits its form as soon as a field in it changes: the lane select on a
// deal's page, and the attachments picker.
import { Controller } from "@hotwired/stimulus";

export default class AutoSubmitController extends Controller<HTMLFormElement> {
  submit(): void {
    this.element.requestSubmit();
  }
}
